
export const GET_MENU_DICTIONARY_REQUESTED = 'menuDictionary/GET_MENU_DICTIONARY_REQUESTED';
export const GET_MENU_DICTIONARY_SUCCESS = 'menuDictionary/GET_MENU_DICTIONARY_SUCCESS';
export const GET_MENU_DICTIONARY_FAILURE = 'menuDictionary/GET_MENU_DICTIONARY_FAILURE';

export const UPDATE_MENU_DICTIONARY_REQUESTED = 'menuDictionary/UPDATE_MENU_DICTIONARY_REQUESTED';
export const UPDATE_MENU_DICTIONARY_SUCCESS = 'menuDictionary/UPDATE_MENU_DICTIONARY_SUCCESS';
export const UPDATE_MENU_DICTIONARY_FAILURE = 'menuDictionary/UPDATE_MENU_DICTIONARY_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  menuDictionaryList: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_DICTIONARY_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_MENU_DICTIONARY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        menuDictionaryList: action.result,
      };
    }
    case GET_MENU_DICTIONARY_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case UPDATE_MENU_DICTIONARY_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_MENU_DICTIONARY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_MENU_DICTIONARY_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getMenuDictionaryByBrand = (brandId) => {
  return {
    types: [GET_MENU_DICTIONARY_REQUESTED, GET_MENU_DICTIONARY_SUCCESS, GET_MENU_DICTIONARY_FAILURE],
    promise: client => client.get(`getMenuDictionaryByBrandId/${brandId}`)
  };
};


export const updateMenuDictionaryData = (brandId, data) => {
  return {
    types: [UPDATE_MENU_DICTIONARY_REQUESTED, UPDATE_MENU_DICTIONARY_SUCCESS, UPDATE_MENU_DICTIONARY_FAILURE],
    promise: client => client.post(`updateMenuDictionary/${brandId}`, { data })
  };
};
